import YYMenu from './menu'
import YYSubmenu from './submenu'
import YYMenuItem from './menu-item'

YYMenu.YYSubmenu = YYSubmenu
YYMenu.YYMenuItem = YYMenuItem
export default YYMenu